import { createAsyncThunk } from "@reduxjs/toolkit";

import { NOTIFY } from "constants/notifyType";
import Notify from "helpers/Notify";
import { privacyPolicyApi } from "service/privacyPolicyApi";

export const getPrivacyPolicy = createAsyncThunk(
  "getPrivacyPolicy",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await privacyPolicyApi.getPrivacyPolicy();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updatePrivacyPolicy = createAsyncThunk(
  "updatePrivacyPolicy",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const { data: response } = await privacyPolicyApi.updatePrivacyPolicy(data);
      Notify(NOTIFY.type.success, NOTIFY.message.update);
      dispatch(getPrivacyPolicy());
      return response;
    } catch (error) {
      Notify(NOTIFY.type.error, NOTIFY.message.wrong);
      return rejectWithValue(error);
    }
  }
);
